import { Vehicle } from '@esportal/portal-service';

export enum NotificationType {
	Mantenimiento = 'mantenimiento',
	PreITV = 'pre-itv',
	BonoPosventa = 'bono-posventa',
}

export interface Notification {
	// id: string;
	vehicle?: Vehicle;
	notificationType: NotificationType;
	value?: string;
	// date: Date;
}
